import { EIconDefaultId } from 'interfaces/iconBuilder'
import { EIconDefaultColor, EIconDefaultIconName } from './../../interfaces/iconBuilder/index'

export const iconNames: string[] = [
  'fa-solid_truck-loading',
  'hydraulic',
  'ic_baseline-account-tree',
  'ic_baseline-build',
  'ic_baseline-construction',
  'ic_baseline-display-settings',
  'ic_baseline-equalizer',
  'ic_baseline-fire-extinguisher',
  'ic_baseline-format-list-numbered',
  'ic_baseline-hardware',
  'ic_baseline-local-fire-department',
  'ic_baseline-power',
  'ic_baseline-security',
  'ic_baseline-text-snippet',
  'ic_baseline-verified-user',
  'ic_round-miscellaneous-services',
  'ic_sharp-supervised-user-circle',
  'material-symbols_bolt-rounded',
  'material-symbols_database',
  'material-symbols_forklift',
  'material-symbols_headset-mic-rounded',
  'material-symbols_info',
  'material-symbols_local-shipping-rounded',
  'material-symbols_outlet',
  'material-symbols_personal-injury',
  'material-symbols_task',
  'material-symbols_tools-pliers-wire-stripper',
  'material-symbols_tools-power-drill',
  'material-symbols_trolley',
  'material-symbols_warehouse-rounded',
  'ic_baseline-dangerous',
  'ic_baseline-close',
  'ic_baseline-block',
  'ic_baseline-priority-high',
  'ic_outline-front-hand',
  'ic_outline-thumb-up',
  'ic_baseline-edit',
  'ic_baseline-edit-note',
  'ic_outline-description',
  'ic_baseline-help',
  'ic_baseline-warning'
]

export const colors: string[] = ['#00A9EB', '#FA5C7C', '#727CF5', '#E9AC00', '#02A8B5', '#39AFD1', '#FD7E14', '#0BCF97']
export const defaultsColor: EIconDefaultColor[] = [
  EIconDefaultColor.DOCUMENT_TYPE,
  EIconDefaultColor.STEP,
  EIconDefaultColor.BLOCK
]
export const defaultIcons: EIconDefaultIconName[] = [
  EIconDefaultIconName.DOCUMENT_TYPE,
  EIconDefaultIconName.STEP,
  EIconDefaultIconName.BLOCK
]

export const defaultIconIds: EIconDefaultId[] = [
  EIconDefaultId.DOCUMENT_TYPE,
  EIconDefaultId.STEP,
  EIconDefaultId.BLOCK
]
